/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * @fileoverview Side-effect import meant to be loaded in the **browser** before
 * any user code is loaded. Installs hydration support for `LitElement`.
 */

import '@lit-labs/ssr-client/lit-element-hydrate-support.js';
